import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Message from "../../tools/Message";
import {
  Alert,
  Autocomplete,
  Button,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import Spacer from "../../../components/Spacer";
import { useNavigate, useParams } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import MainContainer from "../../../components/MainContainer";
import { headerDataImmo } from "../../../data/modules/logistic-header";
import LoadingTexteBackdrop from "../../tools/LoadingTexteBackdrop";
import {
  FormControl,
  IconButton,
  Collapse,
  AppBar,
  Box,
} from "@material-ui/core";
import VehicleService from "../../../services/VehicleService";
import MissionVehicleDetailAdd from "./MissionVehicleDetailAdd";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import MissionTransportService from "../../../services/MissionTransportService";
import { AntTab, AntTabs } from "../../../components/ant-tab";
import TimeToLeaveIcon from "@mui/icons-material/TimeToLeave";
import CardTravelIcon from "@mui/icons-material/CardTravel";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    elevation: 2,
    borderRadius: "8px !important",
    marginTop: "1.5%",
    boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 2px 0px;",
    width: "100%",
  },
  tab: {
    minWidth: "400px !important",
    fontSize: "0.8rem",
  },
  AppBar: {
    borderRadius: "8px",
    boxShadow: "rgba(0, 0, 0, 0.1) 0px 4px 12px",
  },
  box: {
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
    borderRadius: "8px !important",
    maxWidth: "156vh",
    minWidth: "100vh",
  },
}));

export default function MissionVehicleView() {
  const navigate = useNavigate();
  const classes = useStyles();
  const { id } = useParams();
  const missionId = id ? id : null;
  const [openRows, setOpenRows] = useState({});
  const [formValues, setFormValues] = useState({
    mission_id: missionId,
    agendas: [{ agenda_id: 0, destinations: [] }],
  });
  const [missionData, SetMissionData] = useState({});
  const [confirmationDialog, setConfirmationDialog] = React.useState({
    openDialog: false,
    messageDialog: "Voulez vous vraiment supprimer  ?",
  });
  const [confirmTransport, setConfirmTransport] = useState({// pour la confirmation de la gestion du transport
    open: false,
    mission_id: 0,
  });
  const { openDialog, messageDialog } = confirmationDialog;
  const [message, setMessage] = React.useState({
    open: false,
    color: "green",
    messageInfo: "",
  });
  const { open, color, messageInfo } = message;
  const [affiche, setAffiche] = useState(false);
  const [listedestination, setListedestination] = useState([]);
  const [openLoadingSimpleBackdrop, setOpenLoadingSimpleBackdrop] =
    useState(false);
  const [drivers, setDrivers] = useState([]);
  const [vehicles, setVehicles] = useState([]);
  const [vehicleCaptains, setVehicleCaptains] = useState({}); // pour les chefs de bord
  const [vehicleDetailData, setVehicleDetailData] = useState({
    openDialog: false,
    closeDialog: false,
    missionnary: [],
  });
  const [warning, setWarning] = useState({
    show: false,
    vehicleImm: "",
    index: null,
    tIndex: null,
  });
  const [formRequest, setFormRequest] = useState({
    // pour la demande de la sollicitation voiture
    show: false,
    direction: null,
    description: "",
    missionnaries: {},
    allMissionnaries: [],
    destination: {},
    agendaId: 0,
    missionId: 0,
  });
  const [value, setValue] = useState(0);
  const [confirmationOM, setConfirmationOM] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [captainConfirm, setCaptainConfirm] = useState({
    open: false,
    missionnary: "",
    vehicle: "",
  });
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredOption, setHoveredOption] = useState(null);
  const [currentaxe, setCurrentaxe] = useState({
    open: false,
    depart: "",
    destination1: "",
    destination2: "",
  });
  const [formAxe, setFormAxe] = useState({});
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  const formatPhoneNumber = (value) => {
    const cleaned = value.replace(/\D/g, "");
    const match = cleaned.match(/^(\d{0,3})(\d{0,2})(\d{0,3})(\d{0,2})/);
    if (!match) return "";
    return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`.trim();
  };

  useEffect(() => {
    async function fetchMissionDetails() {
      // recuperaion des données
      setOpenLoadingSimpleBackdrop(true);
      try {
        const result = await MissionTransportService.getDataMission(missionId); // Récupérer les informations de la mission
        if (result?.data) {
          const mission = result.data;
          SetMissionData(mission || {});

          if (mission.agendas?.length) {
            const agendas = mission.agendas;

            let allDestinations = [];
            let allVehicles = [];
            let allDrivers = [];
            const [driversResult, vehiclesResult] = await Promise.all([
              // Récupérer chauffeurs et véhicules
              VehicleService.getDriversMission(),
              VehicleService.getAllVehicles(),
            ]);

            if (driversResult?.data) {
              allDrivers = driversResult.data;
              setDrivers(driversResult.data);
            }
            if (vehiclesResult?.data) {
              allVehicles = vehiclesResult.data;
              setVehicles(vehiclesResult.data);
            }

            for (const agenda of agendas) {
              // Parcourir chaque agenda
              if (agenda?.mission_planning_agenda_id) {
                const agendaDestinations =
                  await MissionTransportService.getagendaTransport(
                    agenda.mission_planning_agenda_id
                  ); // Récupérer les détails de l'agenda
                if (agendaDestinations?.data) {
                  setAffiche(true);
                  setListedestination((prev) => [
                    ...prev,
                    {
                      agenda_id: agenda.mission_planning_agenda_id,
                      destinations: agendaDestinations.data,
                    },
                  ]);

                  const transformedDestinations = agendaDestinations.data.map(
                    (item) => {
                      // Transformer les destinations de l'agenda
                
                      setIsEdit(item.transports && item.transports.length > 0); // Vérifier si c'est un mode modification
                      return {
                        mission_destination_id: item.mission_destination_id,
                        transports:
                          item.transports && item.transports.length > 0 // transports : pour les transports déjà configuré / il s'agit d'une modification
                            ? item.transports.map((transport) => {
                                const vehicle =
                                  allVehicles.find(
                                    (v) =>
                                      v.vhc_id ===
                                      transport.mission_planning_voiture_id
                                  ) || null;
                                const driver =
                                  vehicle?.vhc_type == "FID"
                                    ? allDrivers.find(
                                        (d) => d.user_id === vehicle?.driver_id
                                      )
                                    : vehicle?.driver_name || null;
                                const captain = transport.missionnaries.find(
                                        (u) => u.user_id == transport.captain_id
                                      ) || null;

                                return {
                                  type: vehicle?.vhc_type || "FID",
                                  vehicle,
                                  driver,
                                  driverContact: "",
                                  captain,
                                  missionnaries: transport.missionnaries,
                                  missionary_timesheet_mobility_id:
                                    transport.missionary_timesheet_mobility_id,
                                  purpose: transport.transport_purpose,
                                };
                              })
                            : [
                                {
                                  // si il n'y a pas encore de transports configuré, initialiser avec une valeur par défaut
                                  type: "",
                                  vehicle: null,
                                  driver: null,
                                  driverContact: "",
                                  captain: null,
                                  missionnaries: item.missionnaries,
                                  purpose: null,
                                },
                              ],
                      };
                    }
                  );
                  allDestinations.push({
                    agenda_id: agenda.mission_planning_agenda_id,
                    reference: agenda.reference,
                    destinations: transformedDestinations,
                  });
                }
              }
            }
            setFormValues((prev) => ({
              ...prev,
              agendas: allDestinations,
            }));
          }
        } else {
          SetMissionData({});
        }
      } catch (error) {
        console.error("Error fetching mission details:", error);
      } finally {
        setOpenLoadingSimpleBackdrop(false);
      }
    }

    // Appel des fonctions pour récupérer les données
    fetchMissionDetails();
  }, [missionId]);

  useEffect(() => {
    function handleColapse() {
      // pour reinitialiser les lignes ouvertes
      const newOpenRows = {};
      listedestination.forEach((_, index) => {
        newOpenRows[index] = true;
      });
      setOpenRows(newOpenRows);
    }
    handleColapse();
  }, [listedestination]);

  function handleCloseMessage() {
    // fermeture de la message
    setMessage({ ...message, open: false });
  }
  function handleCaptainChange(
    captain,
    vehicle,
    agendaIndex,
    destinationIndex,
    transportIndex
  ) {
    // Gestion du changement de chef de bord
    if (vehicle && captain) {
      let vehicleId = vehicle?.vhc_id;
      setCaptainConfirm({
        open: true,
        missionnary: captain.nom,
        vehicle: vehicleId,
        immatriculation:
          formValues.agendas[agendaIndex].destinations[destinationIndex]
            ?.transports[transportIndex]?.vehicle?.vhc_imm,
      });
      setVehicleCaptains((prevCaptains) => ({
        ...prevCaptains,
        [vehicleId]: captain,
      }));
    }
  }
  const handleClose = () => {
    navigate("/Logistic/mission/transport_managment");
  };

  function handleCloseMessage() {
    setMessage({ ...message, open: false });
  }

  const handleOpenDialogDetail = () => {
    setVehicleDetailData({
      ...vehicleDetailData,
      openDialog: true,
    });
  };

  const handleCloseDialogDetail = () => {
    setVehicleDetailData({ ...vehicleDetailData, openDialog: false });
  };

  const handleToggleRow = (index) => {
    setOpenRows((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <React.Fragment>
      <MissionVehicleDetailAdd
        openDialog={vehicleDetailData.openDialog}
        closeDialog={handleCloseDialogDetail}
        missionnary={missionData?.missionnary}
      />
      <MainContainer {...headerDataImmo}>
        <LoadingTexteBackdrop
          openLoadingSimpleBackdrop={openLoadingSimpleBackdrop}
        />
        <Message
          open={open}
          color={color}
          messageInfo={messageInfo}
          handleClose={handleCloseMessage}
        />

        <AppBar position="static" color="default" className={classes.AppBar}>
          <AntTabs
            value={value}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
          >
            <AntTab
              disableRipple
              label="Gestion de transport par ligne de l'agenda"
              className={classes.tab}
            />
          </AntTabs>
        </AppBar>
        <Spacer y={2} />
        <Grid
          container
          xs={12}
          spacing={2}
          justifyContent="center"
          display="flex"
          flexDirection="row"
          sx={{ margin: "0.25%" }}
        >
          <Grid item xs={12} sm={6} md={4}>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>
                Réference de la mission
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.reference}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>
                {" "}
                Lieu(x) de(s) destination(s)
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.lieu}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>Date de debut</label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={formatDate(missionData.date_begin)}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12} sm={6} md={6}>
              <label className={classes.labelPosition}>Date de fin</label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={formatDate(missionData.date_end)}
                name="name"
                type="text"
                style={{ width: "300px" }}
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Grid item xs={12}>
              <label className={classes.labelPosition}>
                {" "}
                Objet de la mission
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.mission_title}
                name="code"
                type="text"
                fullWidth
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12}>
              <label className={classes.labelPosition}>
                {" "}
                Moyen(s) de transport{" "}
              </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                id="outlined-basic"
                size="small"
                variant="outlined"
                value={missionData.transports}
                name="code"
                type="text"
                fullWidth
                disabled
              />
              <Spacer y={1}></Spacer>
            </Grid>
            <Grid item xs={12}>
              <label className={classes.labelPosition}>Missionnaires </label>
              <Spacer y={0.2}></Spacer>
              <TextField
                multiline
                rows={4}
                value={
                  missionData?.missionnaries
                    ? missionData.missionnaries
                        .map((user) => `- ${user.name}`)
                        .join("\n")
                    : ""
                }
                variant="outlined"
                fullWidth
                disabled
                sx={{ width: 100 }}
                InputProps={{
                  sx: {
                    overflow: "auto",
                  },
                }}
              />
            </Grid>
          </Grid>
        </Grid>

        <Grid container spacing={2} padding="2">
          <Paper variant="outlined" className={classes.paper}>
            {affiche && (
              <Grid container sx={{ margin: 2, width: "100%" }}>
                {formValues.agendas?.map(
                  (
                    agenda,
                    agendaIndex // Boucle sur les agendas
                  ) => (
                    <Grid item xs={12} key={agendaIndex} container>
                      <fieldset
                        style={{
                          borderRadius: "10px",
                          color: "#1976d2",
                          fontSize: "24px",
                        }}
                      >
                        <legend>
                          &nbsp;&nbsp;
                          {`Agenda ${agendaIndex + 1} : ${agenda.reference}`}
                          &nbsp; &nbsp;
                        </legend>
                        <Grid item xs={12}>
                          <Table
                            sx={{ minWidth: 650 }}
                            aria-label="simple table"
                          >
                            <TableHead
                              sx={{
                                backgroundColor: "rgba(0, 0, 0, 0.8)",
                                maxHeight: "10px !important",
                              }}
                            >
                              <TableRow>
                                <TableCell sx={{ width: 10 }} />
                                <TableCell sx={{ width: 150 }}>Date</TableCell>
                                <TableCell sx={{ width: 200 }}>Heure</TableCell>
                                <TableCell sx={{ width: 240 }}>Lieu</TableCell>
                                <TableCell sx={{ width: 300 }}>
                                  Transport souhaité
                                </TableCell>
                                <TableCell sx={{ width: 150 }}>Type</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {listedestination
                                .find(
                                  (dest) => dest.agenda_id === agenda.agenda_id
                                )
                                ?.destinations.map((destination, index) => (
                                  <React.Fragment key={index}>
                                    <TableRow
                                      sx={{
                                        backgroundColor: openRows[index]
                                          ? "rgba(242, 242, 242, 0.8)"
                                          : "inherit",
                                        "&:hover": {
                                          backgroundColor:
                                            "rgba(0, 123, 255, 0.1)",
                                        },
                                      }}
                                    >
                                      <TableCell>
                                        <span style={{ color: "#1976d2" }}>
                                          {index + 1}.
                                        </span>
                                        <IconButton
                                          size="small"
                                          onClick={() => handleToggleRow(index)}
                                        >
                                          {openRows[index] ? (
                                            <KeyboardArrowUp color="info" />
                                          ) : (
                                            <KeyboardArrowDown color="info" />
                                          )}
                                        </IconButton>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {formatDate(destination.date_begin)} -{" "}
                                          {formatDate(destination.date_end)}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {`${destination.heure_begin} - ${destination.heure_end}`}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {destination.type === "DR"
                                            ? `${destination.depart} - ${destination.arriver}`
                                            : destination.activite === "mis"
                                            ? destination.region
                                            : destination.direction_code}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        <label
                                          className={classes.labelPosition}
                                          style={{
                                            color: "grey",
                                            fontSize: "16px",
                                          }}
                                        >
                                          {destination.transport_type}
                                        </label>
                                      </TableCell>
                                      <TableCell>
                                        {destination.type === "DM" ? (
                                          <Chip
                                            icon={<CardTravelIcon />}
                                            label="Mission"
                                            variant="outlined"
                                            color="info"
                                          />
                                        ) : (
                                          <Chip
                                            icon={<TimeToLeaveIcon />}
                                            label="Délai de route"
                                            variant="outlined"
                                            color="info"
                                          />
                                        )}
                                      </TableCell>
                                    </TableRow>

                                    {/* Sous-tableau des détails */}
                                    <TableRow>
                                      <TableCell
                                        style={{
                                          paddingBottom: 0,
                                          paddingTop: 0,
                                        }}
                                        colSpan={6}
                                      >
                                        <Collapse
                                          in={openRows[index]}
                                          timeout="auto"
                                          unmountOnExit
                                        >
                                          <Spacer y={1} />
                                          <div
                                            style={{
                                              display: "flex",
                                              justifyContent: "space-between",
                                              alignItems: "center",
                                            }}
                                          >
                                            <label
                                              className={classes.labelPosition}
                                              style={{
                                                color: "grey",
                                                marginTop: "5px",
                                                fontWeight: "bold",
                                              }}
                                            >
                                              Détails voiture(s)
                                            </label>
                                          </div>
                                          {warning.show &&
                                          warning.index === index ? (
                                            <Alert severity="warning" fullWidth>
                                              Le nombre de missionnaires dépasse
                                              la capacité du voiture{" "}
                                              {warning.vehicleImm}
                                            </Alert>
                                          ) : null}
                                          <Box className={classes.box}>
                                            <TableContainer
                                              component={Paper}
                                              style={{
                                                overflowX: "auto",
                                                marginTop: "1%",
                                                marginBottom: "2%",
                                                boxShadow:
                                                  "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                                borderRadius: "6px",
                                                marginLeft: "0.5%",
                                                width: "99%",
                                              }}
                                            >
                                              <Table size="small" aria-label="sous-tableau"
                                              >
                                                <TableRow>
                                                  {(destination.transport_type.toUpperCase() ==
                                                    "AVION" ||
                                                    destination.transport_type.toUpperCase() ==
                                                      "BATEAU") &&
                                                  destination.type === "DR" ? (
                                                    <TableCell
                                                      style={{
                                                        fontWeight: "bold",
                                                        minWidth: "200px",
                                                      }}
                                                    >
                                                      Type
                                                    </TableCell>
                                                  ) : null}
                                                  <TableCell
                                                    style={{
                                                      fontWeight: "bold",
                                                      minWidth: "360px",
                                                    }}
                                                  >
                                                    Voiture
                                                  </TableCell>
                                                  <TableCell
                                                    style={{
                                                      fontWeight: "bold",
                                                      minWidth: "360px",
                                                    }}
                                                  >
                                                    Chef de bord
                                                  </TableCell>
                                                  <TableCell
                                                    style={{
                                                      fontWeight: "bold",
                                                      minWidth: "280px",
                                                    }}
                                                  >
                                                    Missionnaire(s)
                                                  </TableCell>
                                                </TableRow>
                                                <TableBody>
                                                  {/* Boucle sur les transports associés à la destination */}
                                                  {(
                                                    agenda.destinations.find(
                                                      (dest) =>
                                                        dest.id ===
                                                        destination.id
                                                    )?.transports || []
                                                  ).map((transport, tIndex) => (
                                                 transport.vehicle ?
                                                    <TableRow key={tIndex}>
                                                      {(destination.transport_type.toUpperCase() ==
                                                        "AVION" ||
                                                        destination.transport_type.toUpperCase() ==
                                                          "BATEAU") &&
                                                      destination.type ===
                                                        "DR" ? (
                                                        <TableCell>
                                                          <FormControl
                                                            fullWidth
                                                            variant="outlined"
                                                            size="small"
                                                          >
                                                            <label >{
                                                                transport.purpose
                                                              }</label>
                                                            
                                                          </FormControl>
                                                        </TableCell>
                                                      ) : null}
                                                      <TableCell
                                                        style={{
                                                          minWidth: "360px",
                                                        }}
                                                      >
                                                        <FormControl
                                                          fullWidth
                                                          variant="outlined"
                                                          size="small"
                                                        >
                                                          <label>{ `${transport?.vehicle?.vhc_imm} (voiture ${transport?.vehicle?.vhc_type})`}</label>
                                                         
                                                          <Spacer y={1} />
                                                             <label>Chauffeur : {
                                                            transport.type ===
                                                            "FID"
                                                              ? transport
                                                                  ?.driver
                                                                  ?.name || ""
                                                              : transport?.driver ||
                                                                ""
                                                          }</label>
                                                        </FormControl>
                                                      </TableCell>
                                                      <TableCell
                                                        style={{
                                                          minWidth: "360px",
                                                        }}
                                                      >
                                                        <label className={classes.labelPosition}>
                                                          { transport.captain
                                                              ? transport.captain?.nom?.toString()
                                                              : ""}
                                                          </label>
                                                      </TableCell>
                                                      <TableCell
                                                        style={{
                                                          minWidth: "280px",
                                                        }}
                                                      >
                                                        <Autocomplete
                                                          multiple
                                                          options={
                                                            destination?.missionnaries ||
                                                            []
                                                          }
                                                          getOptionLabel={(
                                                            option
                                                          ) =>
                                                            option
                                                              ? option?.nom?.toString()
                                                              : ""
                                                          }
                                                          filterSelectedOptions
                                                          readOnly
                                                          value={
                                                            transport.missionnaries
                                                          }
                                                          renderInput={(
                                                            params
                                                          ) => (
                                                            <TextField
                                                              {...params}
                                                              label="Missionnaire"
                                                              variant="outlined"
                                                              size="small"
                                                            />
                                                          )}
                                                        />
                                                      </TableCell>

                                                     
                                                    </TableRow>
                                                    : <TableRow key={tIndex}>
                                                     <Alert severity="info"> Transport non configuré pour cette destination
                                                      .</Alert>
                                                      </TableRow>
                                                  ))}
                                                </TableBody>
                                              </Table>
                                            </TableContainer>
                                          </Box>
                                        </Collapse>
                                      </TableCell>
                                    </TableRow>
                                  </React.Fragment>
                                ))}
                            </TableBody>
                          </Table>
                        </Grid>
                      </fieldset>
                    </Grid>
                  )
                )}
              </Grid>
            )}
            <Box
              container
              item
              xs={12}
              spacing={2}
              display="flex"
              justifyContent="flex-end"
              sx={{ marginTop: "20px", marginBottom: "20px" }}
            >
              <Button
                variant="contained"
                color="error"
                size="medium"
                style={{ marginRight: "30px" }}
                onClick={handleClose}
                autoFocus
              >
                Fermer
              </Button>
            </Box>
          </Paper>
        </Grid>
      </MainContainer>
    </React.Fragment>
  );
}
